<template>
  <div :class="{'align-center': $attrs.align ==='center','sent':isSent}" class="input-mobile">
    <input
      v-model="inputValue"
      v-bind="$attrs"
      @change="changeHandle"
      @keyup="changeHandle"
      class="form-control"
      type="tel"
    ></input>
    <div v-if="verify && !verified" class="verify-input">
      <button
        :disabled="!isValidMobile || sent || verifying"
        @click="sendCode"
        class="btn btn-secondary"
        type="button"
        >
        <span v-if="sent">
          {{ t('register.code_sent') }} ({{ countdown }}s)
        </span>
        <span v-else>
          {{ isSent ? t('register.resend_code') : t('register.get_code') }}
        </span>
        </button>
      <input
       ref="code"
       :placeholder="t('register.code')"
        type="tel"
        maxlength="4"
        minlength="4"
        name="smsVerifyCode"
      ></input>
      </div>
    <i v-if="verified" class="fa fa-check"></i>
    </div>
  </div>
</template>
<script>
import commonFunc from "../../assets/js/commonHelper";
export default {
  name: "MobileInput",
  inheritAttrs: false,
  props: {
    verify: {
      type: Boolean,
      default: true,
    },
    verified: {
      type: Boolean,
      default: false,
    },
    verifying: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      countdown: 60,
      inputValue: this.$attrs.value,
      isValidMobile: false,
      sent: false,
      isSent: false,
    };
  },
  computed: {
    // isValidMobile() {
    //   console.log(this.inputValue)
    //   return commonFunc.isValidPhone(this.inputValue)
    // },
  },
  async mounted() {
    this.isValidMobile = commonFunc.isValidPhone(this.inputValue);
    try {
      await this.$recaptcha.init()
    } catch (e) {
      console.error(e);
    }
  },
  beforeDestroy() {
    this.$recaptcha.destroy();
  },
  methods: {
    sendCode: function () {
      if (this.inputValue === "" || !commonFunc.isValidPhone(this.inputValue)) {
        commonFunc.toast(this.t("register.mobile_require"), "warning");
        return;
      }
      if (this.sent) {
        return;
      }
      const vm = this;
      const data = {
        mobile: "+852" + this.inputValue,
        type: "verifyMobile",
      };
      const reqUrl = "/auth/sendSmsCode";
      this.sent = true;
      this.countdown = 60;
      this.$recaptcha.execute('varifyGRecaptcha').then((recaptchaToken) => {
        const headers = { 'recaptcha-response': recaptchaToken };
        this.$axios
          .post(reqUrl, data, { headers: headers })
          .then(function (response) {
            if (response.data.success) {
              commonFunc.toast(vm.t("register.check_sms"), "success");
              vm.isSent = true;
              vm.$refs.code.focus();
            } else {
              commonFunc.toast(response.data.message, "danger");
              vm.sent = false;
            }
          })
          .catch((e) => {
            console.error(e);
            vm.sent = false;
          });
      });
      this.triggerCountdown();
    },
    triggerCountdown() {
      this.countdown = parseInt(this.countdown) - 1;
      if (this.countdown <= 0) {
        this.sent = false;
        return;
      }
      this.interval = setTimeout(this.triggerCountdown, 1000);
    },
    changeHandle(e) {
      this.isValidMobile = commonFunc.isValidPhone(this.inputValue);
      this.$emit("change", this.inputValue);
    },
  },
};
</script>
